import { CancellationType } from "../../enums";

export const POSSIBLE_CHOICES_LABELS = {
  [CancellationType.Airline]: "lp_sc_cancellation_choice_airline",
  [CancellationType.Priority]: "lp_sc_cancellation_choice_priority",
  [CancellationType.Standard]: "lp_sc_cancellation_choice_standard",
  [CancellationType.Voucher]: "lp_sc_cancellation_choice_voucher",
};
